<div class="bx--row">
  <div class="bx--col-lg-10 bx--col-md-5 bx--col-sm-8 bx--col-xs-8">
    <h4 class="header-title">{{title}}<i class="{{icon}}"></i></h4>
    <span
          *ngIf="subtitle.trim()" [ngClass]="mobileSubtitle ? 'header-subtitle' : 'd-none d-sm-block header-subtitle' ">{{subtitle}}</span>
  </div>
  <div class="bx--col-lg-6 bx--col-md-3 bx--col-sm-8 bx--col-xs-8">
    <div style="float: right; display: flex; flex-direction: row;">
        <span class="d-none d-sm-block" *ngIf="secondaryAction">
          <beaconstac-button (onClick)="onClickSecondaryAction.emit()"
                             [useCustomImage]="useCustomImageIconSecondaryAction"
                             [iconSize]="{'font-size': iconCssSecondaryAction}"
                             [icon]="secondaryActionIcon"
                             [disabled]="disableSecondaryButton"
                             [type]="secondaryActionButtonType" [label]="secondaryActionTitle"
                             [style]="secondaryActionButtonStyle"
          ></beaconstac-button>
        </span>
      <span class="d-none d-sm-block" *ngIf="primaryAction"  style="margin-left: 16px">
          <beaconstac-button (onClick)="onClickPrimaryAction.emit()"
                             [useCustomImage]="useCustomImageIconPrimaryAction"
                             [iconSize]="{'font-size': iconCssPrimaryAction}"
                             [icon]="primaryActionIcon"
                             [disabled]="disablePrimaryButton"
                             [type]="primaryActionButtonType" [label]="primaryActionTitle"
                             [style]="primaryActionButtonStyle"
          ></beaconstac-button>
        </span>
    </div>
    <div class="d-sm-none bx--row">
      <div *ngIf="secondaryAction" class="bx--col">
        <beaconstac-button (onClick)="onClickSecondaryAction.emit()"
                           [useCustomImage]="useCustomImageIconSecondaryAction"
                           [iconSize]="iconCssSecondaryAction"
                           [icon]="secondaryActionIcon"
                           [type]="secondaryActionButtonType" [label]="secondaryActionTitle"
                           [style]="secondaryActionButtonStyle"
        ></beaconstac-button>
      </div>
      <div *ngIf="primaryAction"  class="bx--col">
        <beaconstac-button (onClick)="onClickPrimaryAction.emit()"
                           [useCustomImage]="useCustomImageIconPrimaryAction"
                           [iconSize]="iconCssPrimaryAction"
                           [icon]="primaryActionIcon"
                           [type]="primaryActionButtonType" [label]="primaryActionTitle"
                           [style]="primaryActionButtonStyle"
        ></beaconstac-button>
      </div>
    </div>
  </div>
</div>
